<template>
  <v-layout column v-if="asset && asset.id">
    <v-flex v-if="visibleForUser">
        <v-layout>
          <top-info-panel>
            <v-flex xs12 md12 lg6 xl6 px-2 pb-3 slot="content">
              <v-layout row>
                <v-btn color="accent" fab class="btn-edit-asset mr-4" @click="editMode = true" v-show="!editMode"> <v-icon>edit</v-icon></v-btn>
                <v-btn color="accent" fab class="btn-edit-asset mr-4" @click="editMode = false" v-show="editMode"> <v-icon class="fas fa-undo"></v-icon></v-btn>
                <v-flex xs10 justify-center style="z-index:1000;">
                  <h4>Dossier voor {{asset.name}}</h4>Het dossier voor uw assets bevat zowel de actuele status alsmede de historische data (indien aanwezig). Gebeurtenissen, acties en tijdlijn data kunnen hier worden ingezien.
                </v-flex>
                <v-flex class="topbar-icon">
                  <i :class="`${asset.group.icon}  primary--text text--lighten-2`"></i>
                  <!-- <font-awesome-icon icon="gas-pump" class="asset-icon" /> -->
                </v-flex>
              </v-layout>         
            </v-flex>        
          </top-info-panel>
        </v-layout>
        
        <v-layout wrap px-3 align-center justify-center class="inset">
          <v-flex xs12 md12 lg12 xl8 pt-2 v-if="editMode">
            <v-widget :enableHeader="false">      
              <v-layout slot="widget-content" >
                  <edit-asset :asset="asset" @assetSaved="assetIsSaved"></edit-asset>
              </v-layout>    
            </v-widget>
          </v-flex>
                        
          <v-flex xs12 md12 lg12 xl12 pt-2 v-if="!editMode">
            <v-widget :enableHeader="true">               
              <v-layout slot="widget-header-action" >                               
                  <v-spacer></v-spacer>
                  <v-flex justify-end style="display: flex;" align-center>
                    <v-btn flat small :color="(showTarget == 'overview') ? 'accent' : 'primary'" @click="view('overview') ">Overzicht</v-btn>
                    <v-btn flat small :color="(showTarget == 'locations') ? 'accent' : 'primary'" @click="view('locations') ">Locaties</v-btn>
                    <v-btn flat small color="primary" disabled>Notificaties</v-btn>
                    <v-btn flat small color="primary" @click="editMode = true">Configuratie</v-btn>
                    <v-tooltip left >
                      <i slot="activator"  @click="favoritePannelOpen=true" style="color:#FF6C3D" :class="favoriteClass"></i>     
                      <span>Klik om deze asset als favoriet in te stellen</span>
                    </v-tooltip>                                  
                  </v-flex>
              </v-layout>
              <v-layout slot="widget-content" v-show="showTarget == 'overview'" >
                <v-layout row wrap slot="content" px-1 py-1>
                  <v-flex lg7 d-flex>
                    <v-layout column>
                      <v-flex>
                        <v-layout row>
                          <v-flex lg6 d-flex px-2 py-2>
                            <v-card color="primary" class="white--text">
                              <v-layout>
                                <v-flex xs8>
                                  <v-card-title primary-title>
                                    <div>
                                      <div class="headline">{{asset.name}}</div>
                                      <div>
                                        Groep:
                                        <i>{{asset.group.name}}</i>
                                      </div>
                                      <div>
                                        Type:
                                        <i>{{asset.type.name}}</i>
                                      </div>
                                    </div>
                                  </v-card-title>
                                </v-flex>
                                <v-flex xs4 align-center d-flex class="text-xs-right">
                                  <i :class="`${asset.group.icon} fa-5x card-watermark`"></i>                              
                                </v-flex>                            
                              </v-layout>

                              <v-divider light></v-divider>
                              <v-card-actions class="pa-3 white black--text">Healthcheck
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                  <span slot="activator">
                                    <v-icon
                                      v-for="i in 5"
                                      :key="`hcitem_${i}`"
                                      :color="(i <= healthcheck.count) ? healthcheck.color : 'back'"
                                    >
                                      <template v-if="i <= healthcheck.count">radio_button_checked</template>
                                      <template v-else>radio_button_unchecked</template>
                                    </v-icon>
                                  </span>
                                  <span>{{healthcheck.hint}}</span>
                                </v-tooltip>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                          <v-flex xs12 md8 lg6 style d-flex px-2 py-2>
                            <v-card color="white" v-if="asset.hasRoutes">
                              <v-layout
                                column
                                v-if="!asset.movementStatus"
                                class="dd-align-center"
                                style="height: 200px;"
                              >
                                <v-card-title d-flex>
                                  <v-flex class="text-xs-center">
                                    <i class="fas fa-parking fa-5x blue--text"></i>
                                    <br>
                                    <h5>Dit voertuig staat geparkeerd</h5>
                                    <template v-if="asset.inGeoZone"> 
                                        <h5>Op point of interest: {{asset.inGeoZone.name}}</h5>
                                    </template>
                                    <template v-else>
                                        <h5>{{asset.city}}, {{asset.street}} {{asset.house_number}}</h5>
                                    </template>
                                  </v-flex>
                                </v-card-title>
                              </v-layout>
                              <v-layout
                                column
                                v-else
                                class="dd-align-center"
                                style="height: 200px;"
                                green
                                lighten-1
                              >
                                <v-card-title d-flex>
                                  <v-flex class="text-xs-center">
                                    <i class="fas fa-play fa-5x white--text pt-4"></i>
                                    <br>
                                    
                                    <p
                                      class="pt-2"
                                      style="font-weight: 600; font-size:20px; color: #fff;"
                                    >{{ asset.movementStatus.startTime | time}} vertrokken vanaf {{asset.movementStatus.startAddress.data.street}} te {{asset.movementStatus.startAddress.data.city}}</p>
                                  </v-flex>
                                </v-card-title>
                              </v-layout>
                            </v-card>
                            <v-card v-else>

                            <v-carousel class="d-flex" height="220" light hide-delimiters interval="5000"  v-if="(mappedData && mappedData.length > 0) || asset.batteryStatus ">                          
                              <v-carousel-item v-if="asset.batteryStatus" key="data_batteryStatus"  class="dd-graph-carousel">                              
                                  <graph-icon-label-card
                                    :value="batteryStatusName"
                                    symbol=""
                                    caption="Batterij status"
                                    typeInternal="string"
                                    :color="accentColor"
                                    :icon="batteryStatusIcon"
                                    class="d-flex"
                                    >
                                  </graph-icon-label-card>                            
                              </v-carousel-item>                                
                              <v-carousel-item v-for="data in mappedData" :key="data.name"  class="dd-graph-carousel">                              
                                  <graph-circular-card
                                    :value="graphValue(data)"
                                    :symbol="data.typeShort"
                                    
                                    :caption="data.name"
                                    class="d-flex"
                                    v-if="data.typeInternal == 'xpercentage'"
                                  ></graph-circular-card>
                                  <graph-icon-label-card
                                    :value="graphValue(data)"
                                    :symbol="data.typeShort"
                                    :caption="data.name"
                                    :typeInternal="data.typeInternal"
                                    :color="accentColor"
                                    :icon="data.icon"
                                    class="d-flex"
                                    v-else>
                                  </graph-icon-label-card>                            
                              </v-carousel-item>                                
                            </v-carousel>

                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 md12 lg12 d-flex>
                        <v-layout >
                          <v-flex xs12 md12 lg6 d-flex px-2 py-2>
                            <v-card color="orange lighten-2" dark v-show="showMap">
                              <l-map
                                :zoom="zoom"
                                :center="center"
                                :options="mapOptions"
                                :bounds="bounds"
                                style="min-height:300px;"
                              >
                                <l-group v-if="!showRoute">
                                  <l-marker v-if="marker" :lat-lng="marker" :icon="locationIcon"></l-marker>
                                </l-group>
                                <l-group v-if="showRoute">
                                  <l-marker :lat-lng="selectedRouteStart" :icon="startLocationIcon"></l-marker>
                                  <l-marker :lat-lng="selectedRouteEnd" :icon="endLocationIcon"></l-marker>
                                  <l-polyline
                                    :lat-lngs="selectedRoutePolygon"
                                    :color="infoColor"
                                    :fill="false"
                                  ></l-polyline>
                                </l-group>
                                <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>
                                <l-control-zoom position="topright"></l-control-zoom>
                              </l-map>
                              <!-- <v-card-text>i</v-card-text> -->
                            </v-card>
                          </v-flex>
                          <v-flex xs12 md12 lg6 d-flex>
                            <v-layout column >
                              <div class="xs12 md12 lg6 px-2 py-2">
                                <v-card  class="py-4 white--text" :style="`background-color:${assetStatusColor(asset)}; display:flex; height:20px; justify-content: center; align-content:center; align-items:center;flex-direction:column; `">                              
                                    <div><h4>{{statustoString(asset)}}</h4></div>
                                </v-card>
                              </div>
                              <v-flex xs12 md12 lg6 px-2 py-2 d-flex>
                                
                                <v-card class="py-4" v-if="!asset.customFields" style="display: flex; justify-content: center; align-content:center; align-items:center;flex-direction:column;">                              
                                  <div><i class="fas fa-info-circle grey--text text--lighten-2 fa-4x"></i></div>
                                  <div><h4 class="grey--text text--lighten-2">Geen extra velden geconfigureerd</h4></div>
                                </v-card>
                                <v-card v-else>
                                  <v-layout row wrap px-4 py-2 v-if="customFields">                                
                                    <v-flex sm12 lg6 v-for="cf in customFields" :key="cf.name">
                                        <div class="dd-label">{{cf.name}}</div>
                                        <div class="dd-value">{{cf.value}}</div>
                                    </v-flex>                                
                                  </v-layout>
                                </v-card>
                              </v-flex>
                              <v-flex xs12 md12 lg6 px-2 py-2 :class="{'d-flex': !asset.mainImage}">
                                <v-card v-if="!asset.mainImage" color="secondary" style="display: flex; justify-content: center; align-content:center; align-items:center;flex-direction:column;">                              
                                  <div><i class="fas fa-camera white--text fa-4x"></i></div>
                                  <div><h4 class="white--text ">Geen foto ingesteld</h4></div>
                                </v-card>
                                <v-card v-else > 
                                  <v-img :src="imageUrl" contain>
                                    <v-container fill-height fluid pa-2>
                                        <v-layout fill-height>
                                          <v-flex xs12 align-end flexbox  >
                                            <span class=" white--text px-4 py-1" style="background-color: rgba(0,0,0,0.5); font-size:18px;" v-text="asset.mainImage.title"></span>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                  </v-img>
                                  <!-- <img :src="imageUrl" class="dd-uploaded-image" style='height: 100%; width: 100%; object-fit: contain'>   -->
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <!-- hier stonden events achter kaart -->
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex d-flex lg5 align-baseline>
                    <v-layout row>
                      <v-flex lg12 d-flex px-2 py-2>
                        <v-card lg12>
                          <v-tabs v-model="selectedTab" grow>
                            <v-tab key="events" :disabled="processedEvents && processedEvents.length==0">Logboek</v-tab>
                            <v-tab key="routes" :disabled="!asset.hasRoutes">Ritten</v-tab>
                            <v-tab key="timeseries" >Datastromen</v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="selectedTab">
                            <!-- LOG TAB ---------------------------->
                            <v-tab-item key="events">
                              <v-card flat>
                                <v-card-text style="padding: 0px 0px;" v-if="asset">
                                  <dossier-log-book :asset="asset"> </dossier-log-book>                  
                                </v-card-text>
                              </v-card>
                            </v-tab-item>                
                            <!-- ROUTE TAB ---------------------------->
                            <v-tab-item key="routes">
                              <v-card flat>
                                <v-card-text>
                                  <v-expansion-panel>
                                    <v-expansion-panel-content v-for="route of routes" :key="route.id">
                                      <div slot="header" class="route-overview" @click>
                                        <v-layout row>
                                          <v-flex sm6>
                                            <v-flex>
                                              <span class="mr-4">{{route.startTime | date_nl }}</span>
                                              {{route.fromAddress.city}}
                                              <i
                                                class="fas fa-arrow-right"
                                              ></i>
                                              {{route.toAddress.city}}
                                              <span
                                                class="ml-4"
                                              >{{route.startTime | time }} tot {{route.endTime | time }}</span>
                                              <i class="grey--text"></i>
                                            </v-flex>
                                            <!-- <v-flex>{{((asset.street) ? asset.street : "Onbekende straat")}}, {{asset.city}} </v-flex>                                                 -->
                                          </v-flex>
                                        </v-layout>
                                      </div>
                                      <v-card class="grey lighten-4">
                                        <v-card-text>
                                          <v-layout row>
                                            <v-flex sm12 px-2 style="cursor: pointer;" @click>
                                              <v-layout class="layout" wrap row>
                                                <v-flex xs6 lg6>
                                                  <div class="dd-label">Van</div>
                                                  <div
                                                    class="dd-value"
                                                  >{{route.fromAddress.street}} te {{route.fromAddress.city}}</div>
                                                </v-flex>
                                                <v-flex xs6 lg6>
                                                  <div class="dd-label">Van</div>
                                                  <div
                                                    class="dd-value"
                                                  >{{route.toAddress.street}} te {{route.toAddress.city}}</div>
                                                </v-flex>
                                                <v-flex xs6 lg6>
                                                  <div class="dd-label">Reistijd</div>
                                                  <div
                                                    class="dd-value"
                                                  >{{Math.round(route.duration / 60)}} minuten</div>
                                                </v-flex>
                                                <v-flex xs6 lg6>
                                                  <div class="dd-label">Afstand</div>
                                                  <div
                                                    class="dd-value"
                                                  >{{(route.distance / 1000).toFixed(1)}} kilometer</div>
                                                </v-flex>
                                                <v-flex xs12 lg12>
                                                  <v-layout justify-space-between>
                                                    <div class="route-badge-container">
                                                      <div
                                                        class="route-badge"
                                                        :style="`background-color: ${errorColor}`"
                                                        v-if="routeEfficiencyPercentage(route) > 0"
                                                      >
                                                        <i class="fas fa-angle-up mr-1"></i>
                                                        {{routeEfficiencyPercentage(route)}}%
                                                      </div>
                                                      <div
                                                        class="route-badge"
                                                        :style="`background-color: ${successColor}`"
                                                        v-else
                                                      >
                                                        <i class="fas fa-angle-down mr-1"></i>
                                                        {{routeEfficiencyPercentage(route) * -1}}%
                                                      </div>
                                                    </div>
                                                    <v-btn icon @click="showRouteToMap(route)">
                                                      <v-icon>gps_fixed</v-icon>
                                                    </v-btn>
                                                  </v-layout>
                                                </v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-card-text>
                                      </v-card>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <!-- TIMESERIES TAB ---------------------------->
                            <v-tab-item key="timeseries" v-if="selectedTab == 2">
                              <v-flex xs12>
                                <v-card flat color="teal lighten-1" dark xs12>
                                  <v-card-text>
                                    <TimeSerieLine :serie="timeSerie" lineColor="#eee" d-flex></TimeSerieLine>
                                  </v-card-text>
                                </v-card>
                              </v-flex>
                              <v-flex grey lighten-3 px-4>                
                                <v-select 
                                  item-value="id"                                     
                                  item-text="name"                                     
                                  :items="asset.unitType.timeSeries"
                                  label="Kies een datastroom"
                                  @change="loadTimeSerie()"
                                  v-model="selectedTimeSerieId"
                                ></v-select>
                              </v-flex>                          
                            </v-tab-item>
                          </v-tabs-items>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout v-if="showTarget == 'locations'" slot="widget-content" >       
                <v-flex lg6 d-flex class="dd-asset-map" v-if="markersForLocations">
                  <l-map
                    
                    :zoom="assetLocationsMap.zoom"
                    :center="assetLocationsMap.center"          
                    :bounds="markersForLocationsBounds"
                    
                    >
                    <l-group v-if="markersForLocations.length > 0"> 
                      <l-marker
                        v-for="marker of markersForLocations"                    
                        :latLng="[marker.lat, marker.lon]"
                        :key="marker.positionIndex"
                        :icon="assetPositionIcon(marker)"
                      >
                      </l-marker>
                    </l-group>
                    <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>
                  </l-map>
                </v-flex>
                <v-flex lg6 pl-3>
                  <v-layout column>
                    <v-flex grey lighten-4>
                      <v-layout row px-2 py-1 justify-center>
                        <v-flex lg12 px-2 style="display:flex; justify-content:center;" >

                          <v-menu
                              v-model="showFromDatePicker"                          
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              style="padding: 10px;"
                              min-width="290px"
                          >
                              <v-text-field
                                  slot="activator"                                                         
                                  v-model="locationsFrom"
                                  label="Vanaf datum"
                                  px-2
                                  readonly
                                  >
                              </v-text-field>
                              <v-date-picker  @change="view('locations')"   v-model="locationsFrom" @input="showFromDatePicker = false"></v-date-picker>                          
                          </v-menu>

                          <v-menu 
                              v-model="showTillDatePicker"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              style="padding: 10px;"
                              min-width="290px"
                          >
                              <v-text-field slot="activator" v-model="locationsTill" label="Tot datum" readonly>
                              </v-text-field>
                              <v-date-picker  @change="view('locations')" v-model="locationsTill" @input="showTillDatePicker = false"></v-date-picker>                          
                          </v-menu>         
                          <div class="flex" style="align-content: center; align-items:center; display: flex;">
                            <v-btn class="class" color="secondary" @click="downloadCSV">csv</v-btn> 
                          </div>
                          <div class="flex" style="align-content: center; align-items:center; display: flex;">
                            <v-btn class="class" color="secondary" @click="downloadPDF">pdf</v-btn> 
                          </div>
                          
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex>
                      <v-pagination v-if="assetLocationsMeta && assetLocationsMeta.pagination && assetLocationsMeta.pagination.count > 0"             
                          v-model="currentPage"
                          :length="assetLocationsMeta.pagination.total_pages"                           
                          @input="loadPage">
                      </v-pagination>                                              
                    </v-flex>
                    <v-flex d-flex class="locations-textual">                  
                      <table style="padding:0px;margin:0px;border: 1px solid #e0e0e0;">
                        <template v-for="day of positionsByDay">
                          <tr  :key="day.date" class="day-header">
                            <td colspan="4">{{day.date | date_nl}} </td>                                             
                          </tr>
                          <tr v-for="(row,i) of day.records"  :key="`${row.timestamp}_${i}`" class="location-row" @click="setMapToLocation(row)" @mouseover="highlightedPositionMarker = row.positionIndex" :class="{'highlighted-position-row': (highlightedPositionMarker == row.positionIndex) }">
                            <td style="width: 30px;" class="marker-number">{{row.positionIndex}}</td>
                            <td style="width:110px;padding-left: 8px;">{{row.timestamp | time}}</td>
                            <td style="width:310px;">
                              <span v-if="row.geoZone">{{row.address.city}}</span>
                              <span v-else-if="row.address && row.address.city">{{row.address.city}}</span>
                            </td>
                            <td>
                              <span v-if="row.geoZone">
                                <span :class="streetTypeClass('POI')">{{row.geoZone.name.replace(/;/g," ")}}</span>
                              </span>
                              <span v-else-if="row.address">
                                <span :class="streetTypeClass(row.address.street)">{{row.address.street.replace(/;/g," ")}}</span>
                              </span>                            
                              <span v-else-if="row.lat == 0">Geen locatie bericht</span>
                              <span v-else>Adres onbekend {{row}}</span>
                            </td>
                          </tr>
                        </template>                    
                      </table>
                    </v-flex>
                  </v-layout>
                </v-flex>              
              </v-layout>
            </v-widget>
          </v-flex>
        </v-layout>      
        <asset-user-favorite v-if="favoritePannelOpen"          
            :favorite="isFavorite" 
            :assetId="$route.params.assetId" 
            @favoriteSaved="favoriteSaved()"
            @panelClosed="favoritePannelOpen=false"        
            >
        </asset-user-favorite>         
    </v-flex>        
    <v-flex v-else>
      <v-layout row justify-center align-center>
        <v-flex xs5>
          <h2>Geen rechten om details te bekijken</h2>
        </v-flex>          
      </v-layout>      
    </v-flex>
  </v-layout>
</template>
<script>
import Vue2Leaflet from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from "vuex";
import { MAP_URL, IMAGE_URL } from "../../config.js";
import moment from "moment";
import * as types from "../../store/types";
import { timeDifference } from "../../plugins/core/dd.time";
import VWidget from "../../components/global/VWidget";
import TimeSerieLine from "../../components/graph/TimeSerieLine";
import EditAsset from "../../components/asset/EditAsset";
import GraphCircularCard from "../../components/graph/GraphCircularCard"
import GraphIconLabelCard from "../../components/graph/GraphIconLabelCard"
import TopInfoPanel from "../../components/global/TopInfoPanel";
import ColorMixin from "../../plugins/mixins/ColorMixin.js";
import AssetMixin from "../../plugins/mixins/AssetMixin.js";
import polyLineUtil from "@mapbox/polyline";
import AssetUserFavorite from "../../components/asset/AssetUserFavorite"
import DossierLogBook from "../../components/event/DossierLogBook"
import { downloadAssetPosition } from "../../api/core/assets.dd"

export default {
  components: {
    DossierLogBook,
    AssetUserFavorite,
    TopInfoPanel,
    VWidget,
    TimeSerieLine,
    EditAsset,
    GraphCircularCard,
    GraphIconLabelCard,
    DossierLogBook,
    "l-map": Vue2Leaflet.LMap,
    "l-tilelayer": Vue2Leaflet.LTileLayer,
    "l-marker": Vue2Leaflet.LMarker,
    "l-group": Vue2Leaflet.LLayerGroup,
    "l-popup": Vue2Leaflet.LPopup,
    "l-polyline": Vue2Leaflet.LPolyline,
    "l-tooltip": Vue2Leaflet.LTooltip,
    "l-control-zoom": Vue2Leaflet.LControlZoom
  },
  mixins: [ColorMixin, AssetMixin],
  data() {
    return {
      favoritePannelOpen:false,
      assetLocationsMap: {
        bounds: [52,6],
        center: [52,6],
        zoom: 11
      },
      selectedTimeSerieId:null,
      selectedTab: 0,
      zoom: 11,
      url: MAP_URL, //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
        { id: 10001, position: { lat: 52, lon: 6.1 } },
        { id: 20001, position: { lat: 52.2, lon: 6.2 } }
      ],
      bounds: null,
      mapOptions: { zoomControl: false },
      showMap: true,
      showRoute: false,
      editMode: false,
      showTarget: 'overview',
      locationsFrom: null,
      locationsTill: null,
      showFromDatePicker: false,
      showTillDatePicker: false,
      highlightedPositionMarker: null,
      currentPage:1
    };
  },
  computed: {
    ...mapGetters({      
      asset: types.ASSET,
      routes: types.ASSET_ROUTES,
      timeSerie: types.ASSET_TIME_SERIE,
      processedEvents: types.ASSET_PROCESSED_EVENTS,
      assetLocations: types.ASSET_LOCATIONS,
      assetLocationsMeta: types.ASSET_LOCATIONS_META,      
      assetDossierItems:types.ASSET_DOSSIER_ITEMS,
      assetDossierItemsMeta:types.ASSET_DOSSIER_ITEMS_META,
      currentUser: types.CURRENT_USER,
      userFavoriteAssets: types.USER_FAVORITE_ASSETS,       
    }),
    batteryStatusName(){
      switch(this.asset.batteryStatus){
        case 'FULL' :
          return 'Maximaal';          
        case 'VERY_GOOD' :
          return 'Zeer goed';
        case 'OK' :
          return 'Voldoende';
        case 'LOW' :
          return 'Laag';
        case 'EMPTY' :
          return 'Leeg';
        default :
          return 'Onbekend';
      }
    },
    batteryStatusIcon(){
      switch(this.asset.batteryStatus){
        case 'FULL' :
          return 'far fa-battery-full';          
        case 'VERY_GOOD' :
          return 'far fa-battery-three-quarters';          
        case 'OK' :
          return 'far fa-battery-half';
        case 'LOW' :
          return 'far fa-battery-quarter';
        case 'EMPTY' :
          return 'far fa-battery-empty';
        
        default :
          return 'far fa-battery-slash';
      }
    },
    //TODO: Temp function for Tata Steel Users, remove when normal rights system is active
    visibleForUser(){    
        
        let found = this.currentUser.roles.find((role) => {
            return role.name == "Tata Steel Gebruiker" ? true : false
        })

        // dont show item if user is member of Tata Steel User
        return found ? false : true;
    },    
    mappedData(){
      if(this.asset.customFields.length == 0){
        return []
      }
      return this.asset.customFields.filter((field) => {
          return field.isDataField ? field : false
      })
    },
    customFields(){
      if(this.asset.customFields.length == 0){
        return []
      }

      return this.asset.customFields.filter((field) => {
          return !field.isDataField ? field : false
      })
    },
    isFavorite(){
        let vm = this      
        if(!this.userFavoriteAssets)
          return null

        return this.userFavoriteAssets.find((favorite) => {
            return (favorite.assetId == vm.$route.params.assetId) && favorite.active  ? favorite : null
        })
    },
    favoriteClass(){
      return this.isFavorite && this.isFavorite.active ?  "fas fa-star fa-lg" : "far fa-star fa-lg"
    },    
    positionsByDay(){                          
      let arr = []
      let date
      let prevDate=true
      let first = true;
      let ele
      let i = 0;
      
      if(this.assetLocations){
        this.assetLocations.forEach((record) => {
            date = moment(record.timestamp).format("YMD")  
            
            if(first || date != prevDate){
              first=false
              ele = {date: moment(record.timestamp).format("YYYY-MM-DD"), records: []}                                        
            }

            ele.records.push({...record, positionIndex: this.assetLocations.length - i})                            
                        
            if(first || date != prevDate){
              arr.push(ele)
            }
            i++             
            prevDate = date
        })
      }
      return arr
    },
    markersForLocationsBounds(){
      let arr = []
      if(this.markersForLocations.length == 0){
        
        return null
      }
      for(let marker of this.markersForLocations){
        if(marker.lat && marker.lon){
          arr.push([marker.lat, marker.lon])
        }        
      }
      return arr
    },
    markersForLocations(){      
      let arr = []
      for(let day of this.positionsByDay){
        
        for(let record of day.records){
          if(record && record.lat && record.lon){
            arr.push(record)
          }
          
        }
      }
      
      return arr;
    },
    imageUrl(){
            return `${IMAGE_URL}/${this.asset.mainImage.publicLocation}`;
    },
    selectedRouteStart() {
      return L.latLng(
        this.showRoute.fromAddress.lat,
        this.showRoute.fromAddress.lon
      );
    },
    selectedRouteEnd() {
      return L.latLng(
        this.showRoute.toAddress.lat,
        this.showRoute.toAddress.lon
      );
    },
    selectedRoutePolygon() {
      return polyLineUtil.decode(this.showRoute.geometry, 6);
    },
    hasPosition() {
      return !(!this.asset || !this.asset.lat);
    },
    center() {
      if (!this.hasPosition) {
        return [52.08288179572668, 5.82352638244629];
      } else {
        return [this.asset.lat, this.asset.lon];
      }
    },
    marker() {
      if (this.hasPosition) {
        return L.latLng(this.asset.lat, this.asset.lon);
      } else {
        return null;
      }
    },
    defaultTimeSerie() {
      if(!this.asset)
        return false;

      if(this.asset && this.asset.unitType){
        let res = this.asset.unitType.timeSeries.find(ele => {
          return ele.isPrimary == true;
        });
        
        return res;
      }
    },

    timeSerieLastValue() {
      let ret = {
        color: "secondary",
        value: 0
      };
      if (this.timeSerie) {
        let lastEle = this.timeSerie.serie.slice(-1);
        ret.value = Math.round(lastEle[0].value);
        if (this.timeSerie.unitTypeTimeSerie.unitOfMeasure == "percentage") {
          if (ret.value == 100) {
            ret.color = "green";
          }
          if (ret.value > 90) {
            ret.color = "light-green";
          } else if (ret.value > 70) {
            ret.color = "lime";
          } else if (ret.value > 60) {
            ret.color = "yellow";
          } else if (ret.value > 50) {
            ret.color = "amber";
          } else if (ret.value > 25) {
            ret.color = "orange";
          } else if (ret.value > 15) {
            ret.color = "deep-orange";
          } else {
            ret.color = "red";
          }
        }
      }

      return ret;
    },
    locationIcon() {
      let color = "#e91e63";
      

      let html = `<div class="marker-pin">
                    <div class="inner-pin" style="background-color:${this.infoColor}">
                      <i class="${this.asset.group.icon}"></i>
                    </div>
                  </div>`;

      return L.divIcon({
        iconSize: new L.Point(34, 34),
        iconAnchor: [17, 34],
        someData: "test",
        html
      });
    },
    startLocationIcon() {
      let color = "#e91e63";

      let html = `<div class="marker-pin">
        <div
          class="inner-pin "
          style="background-color:${this.infoColor}">
          <i class="fas fa-play"></i>
        </div>

      </div>`;

      return L.divIcon({
        iconSize: new L.Point(34, 34),
        iconAnchor: [17, 34],
        someData: "test",
        html
      });
    },

    endLocationIcon() {
      let color = "#e91e63";

      let html = `<div class="marker-pin">
                    <div
                      class="inner-pin "
                      style="background-color:${this.infoColor}">
                      <i class="fas fa-stop"></i>
                    </div>
                  </div>`;

      return L.divIcon({
        iconSize: new L.Point(34, 34),
        iconAnchor: [17, 34],
        someData: "test",
        html
      });
    },

    latestEvents() {
      let ret = [];
      let now = moment();
      let lastSeen;
      return ret
      for (let [key, value] of Object.entries(this.asset.lastEvents)) {
        let color = "red";
        if (value.eventName == "REFUEL") {
          color = "#cddc39 ";
        }
        if (value.eventName == "ERR_UNEXPECTED_REBOOT") {
          color = "#b3d4fc";
        }
        lastSeen = moment(value.eventTime);
        ret.push({
          color: color,
          text: value.eventName,
          data: value.data,
          timeString: timeDifference(now, lastSeen)
        });        
      }
   
      return ret;
    },
    healthcheck() {

      if(!this.asset)
        return { count: 0, color: "grey", hint: "Unit not loaded" };
      
      let assetLastSeen = moment(this.asset.positionUpdated);
      let now = moment();
      let lastSeen = moment.duration(now.diff(assetLastSeen)).asMinutes();
            
      if(!this.asset.unitType){
        return {count:1,color:"orange", hint:"Unit not defined"}
      }
      
      let defaultInterval = this.asset.unitType.defaultIntervalMinutes;

      if (lastSeen < defaultInterval) {
        return { count: 5, color: "green", hint: "Unit is OK" };
      } else if (lastSeen < defaultInterval * 1.5) {
        // For test... 1.5 for live
        return {
          count: 4,
          color: "lime",
          hint: "Unit is OK, but missed a package"
        };
      } else if (lastSeen < defaultInterval * 2) {
        return { count: 3, color: "orange", hint: "Unit is delayed" };
      } else if (lastSeen < defaultInterval * 4) {
        return {
          count: 2,
          color: "deep-orange",
          hint: "Unit missed multiple message rounds"
        };
      } else {
        return { count: 1, color: "red", hint: "Unit seems dead" };
      }
    }
  },
  methods: {
    downloadCSV(){
      downloadAssetPosition({
        id: this.asset.id,
        from: this.locationsFrom,
        till: this.locationsTill
      }, { 
          downloadName: `positie-rapportage-${this.asset.name}.csv`,
          fileType: `csv`
      }).then(() => {
        this.$notify('Export download gestart', {type: 'success', icon: 'check'})         
      })
    },
    downloadPDF(){
      downloadAssetPosition({
        id: this.asset.id,
        from: this.locationsFrom,
        till: this.locationsTill
      }, { 
          downloadName: `positie-rapportage-${this.asset.name}.pdf`,
          fileType: `pdf`
      }).then(() => {
        this.$notify('Export download gestart', {type: 'success', icon: 'check'})         
      })
    },
    setMapToLocation(eventData){
         // zoomlocation is saved in global state. But since you can swap between tabs, we need to reset the zoom so the map knows to zoom. 
        // If don't do this, the redrawn map thinks its alrady zoomed in to the given level and therefor doesn't have to change anything.
        if(this.assetLocationsMap.zoom <= 18)
            this.assetLocationsMap.zoom = 19;
        else
            this.assetLocationsMap.zoom = 18;
            
      
        this.$nextTick(() =>
        {
              this.assetLocationsMap.center = [eventData.lat, eventData.lon];
        });
       
        
    },
    favoriteSaved(){
      this.favoritePannelOpen=false
      this.loadFavorites()
    }, 
    view(target){     
      if(target == 'locations'){        
          this.$store.dispatch(types.ASSET_LOCATIONS, {data: {id: this.asset.id, from: this.locationsFrom, till: this.locationsTill}, params:{include:"geoZone",per_page:50,page:this.currentPage}})        
      }
      this.showTarget = target;
    },
    loadPage(pageNr){
       this.currentPage = pageNr
       this.$store.dispatch(types.ASSET_LOCATIONS, {data: {id: this.asset.id, from: this.locationsFrom, till: this.locationsTill}, params:{include:"geoZone",per_page:50,page:this.currentPage}})        
    },
    loadTimeSerie(){

        this.$store.dispatch(types.ASSET_TIME_SERIE,null)

        this.$nextTick( () => {
          this.$store.dispatch(types.ASSET_TIME_SERIE, {
            data: {
                assetId: this.$route.params.assetId,
                timeSerieId: this.selectedTimeSerieId
            },
            params: {
                include: "asset,unitTypeTimeSerie"
              }
            })
            .then(() => {

            });     
        }) 
    },
    assetPositionIcon(position){
      let color = this.primaryColor;
      if(this.highlightedPositionMarker == position.positionIndex){
        color = this.accentColor
      }
      let html = `<div class="marker-pin">
        <div
          class="inner-pin "
          style="background-color:${color}">
          ${position.positionIndex}
        </div>

      </div>`;

      return L.divIcon({
        iconSize: new L.Point(34, 34),
        iconAnchor: [17, 34],
        someData: "test",
        html
      });
    },
    streetTypeClass(street){
      if(street){
        if(street == 'POI'){
          return 'road-poi-type'
        }        
        if(street[0] == 'A' && (parseInt(street[1]) > 0)){
          return 'road-a-type'
        }
        if(street[0] == 'E' && (parseInt(street[1]) > 0)){
          return 'road-e-type'
        }
        if(street[0] == 'N' && (parseInt(street[1]) > 0)){
          return 'road-n-type'
        }
        else{
          return 'road-urban-type'
        }
      }
      return '';
    },
    graphValue(data){      
          
      if(data.dataType == 'numeric' && data.decimals > 0){
        parseFloat(data.value).toFixed(data.decimals)
      }
      return data ? (data.value)  : ""
      
    },
    showRouteToMap(route) {
      this.showRoute = route;
      this.bounds = polyLineUtil.decode(route.geometry, 6);
    },

    actionStatusColor(action) {
      if (action.status.internalName == "open") {
        return this.infoColor;
      }
      if (action.status.internalName == "done") {
        return this.successColor;
      }
      if (action.status.internalName == "cancelled") {
        return this.errorColor;
      }
    },
    routeEfficiencyPercentage(route) {
      return Math.round(
        ((route.duration - route.normalDuration) / route.normalDuration) * 100
      );
    },
    reloadAsset() {

    },

    assetIsSaved(){
      this.editMode = false
      this.$store.dispatch(types.ASSET, {
        data: {
          id: this.$route.params.assetId
        },
        params: {
          include: "currentPosition,lastEvents,group,type,unitType.timeSeries,mainImage"
        }
      })
    },
    colorForEventType(internalName) {
      switch (internalName) {
        case "info":
          return "blue";
        case "warning":
          return "amber";
        case "error":
          return "red";
        case "success":
          return "green";
      }
    },
    colorForEventSeverity(internalName) {
      switch (internalName) {
        case "irrelevant":
          return "#E0E0E0";
        case "low":
          return "#2196F3";
        case "average":
          return "#FF9800";
        case "high":
          return "#F44336";
        case "critical":
          return "#F44336";
      }
    },
    loadFavorites(){
      this.$store.dispatch(types.USER_FAVORITE_ASSETS,{data:{"userId":this.currentUser.id },params:{per_page:200, include:"asset"}})      
    },    
  },
  mounted() {
    // this.$store.dispatch(types.CURRENT_BREADCRUMBS, [
    //   { text: "Home", href: "/", disabled: false },
    //   { text: "Assets", href: "/assets", disabled: false },
    //   {
    //     text: "Asset details FLU0000001",
    //     href: "/assets-details/1",
    //     disabled: true
    //   }
    // ]);
    this.loadFavorites()

    this.locationsFrom = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
    this.locationsTill = moment().format('YYYY-MM-DD');

    this.$store.dispatch(types.FS_LOADING, true);

    let p1 = this.$store
      .dispatch(types.ASSET, {
        data: {
          id: this.$route.params.assetId
        },
        params: {
          include: "currentPosition,lastEvents,group,type,unitType.timeSeries,mainImage,geoZoneEvents"
        }
      })
      .then(() => {

        if (this.defaultTimeSerie) {
          let p2 = this.$store
            .dispatch(types.ASSET_TIME_SERIE, {
              data: {
                assetId: this.$route.params.assetId,
                timeSerieId: this.defaultTimeSerie.id
              },
              params: {
                include: "asset,unitTypeTimeSerie"
              }
            })
            .then(() => {
                this.selectedTimeSerieId = this.defaultTimeSerie.id              
            });
        }
        let p3 = this.$store.dispatch(types.ASSET_PROCESSED_EVENTS, {
          data: {
            id: this.$route.params.assetId
          },
          params: {
            include:
              "itemType,event.eventType,event.eventSeverity"
          }
        })

        let p4 = this.$store.dispatch(types.ASSET_PROCESSED_ACTIONS, {
          data: {
            id: this.$route.params.assetId
          },
          params: {
            per_page: 10,
            include:
              "status,concludedBy,processedEvent.unitTypeEvent,eventAction.doneEvent,eventAction.cancelEvent"
          }
        });

        let p5 = this.$store.dispatch(types.ASSET_ROUTES, {
          data: {
            id: this.$route.params.assetId,
            from: moment()
              .subtract(1, "months")
              .format("YYYY-MM-DD"),
            till: moment()
              .add(1, "days")
              .format("YYYY-MM-DD")
          },
          params: {
            include: "fromAddress,toAddress"
          }
        });

        let p6 = this.$store.dispatch(types.ASSET_DOSSIER_ITEMS, {
          data: {
            assetId: this.$route.params.assetId
          },
          params: {
            include:"itemType,event.eventType,event.eventSeverity,images"
          }
        })

        Promise.all([p3, p4, p5, p6]).then(() => {
          this.$store.dispatch(types.FS_LOADING, false);
        });
      });
    this.$store.dispatch(types.BACKGROUND_ICON, "globe-europe");
  },
  beforeDestroy() {
    this.$store.dispatch(types.BACKGROUND_ICON, null);
  }
};
</script>
<style >




.circle-dot {
  width: 16px;
  height: 16px;
  position: absolute;
  display: inline-block;
  border-radius: 100%;
  line-height: 1.7;
  padding: 0;
  margin-top: 20px;
  margin-left: -8px;
  border-color: rgba(255, 255, 255, 0.8);
  border-width: 2px;
  border-style: solid;
}

.marker-pin {
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 40px 40px 14px 40px;
  position: relative;
  -webkit-transform: rotate(45deg);
  box-shadow: -2px 2px 6px -1px rgba(0, 0, 0, 0.7) !important;
}

.inner-pin > .material-icons {
  font-size: 16px !important;
}
.inner-pin {
  -webkit-transform: rotate(-45deg);
  position: absolute;
  background-color: red;

  width: 26px;
  height: 26px;
  border-radius: 50%;
  margin-top: 2px;
  margin-left: 2px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  font-weight: bold;
  font-stretch: normal;

  line-height: 47px;
  font-family: Helvetica, Arial, sans-serif;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.01), 2px 2px rgba(0, 0, 0, 0.13),
    3px 3px rgba(0, 0, 0, 0.125), 4px 4px rgba(0, 0, 0, 0.02),
    5px 5px rgba(0, 0, 0, 0.015), 6px 6px rgba(0, 0, 0, 0.01),
    7px 6px rgba(0, 0, 0, 0.01), 8px 8px rgba(0, 0, 0, 0.01),
    9px 8px rgba(0, 0, 0, 0.01), 10px 10px rgba(0, 0, 0, 0.01),
    11px 11px rgba(0, 0, 0, 0.01), 12px 12px rgba(0, 0, 0, 0.01),
    13px 13px rgba(0, 0, 0, 0.01), 14px 14px rgba(0, 0, 0, 0.01),
    15px 15px rgba(0, 0, 0, 0.01), 16px 16px rgba(0, 0, 0, 0.01),
    17px 17px rgba(0, 0, 0, 0.01), 18px 18px rgba(0, 0, 0, 0.01),
    19px 19px rgba(0, 0, 0, 0.01), 20px 20px rgba(0, 0, 0, 0.01),
    21px 21px rgba(0, 0, 0, 0.01), 22px 22px rgba(0, 0, 0, 0.01),
    23px 23px rgba(0, 0, 0, 0.01);
  overflow: hidden;
}

@keyframes flickerAnimation {
  /* flame pulses */
  0% {
    opacity: 1;
  }
  /* 20%  { opacity:0.6; } */
  40% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

.ignition-on-pin {
  opacity: 1;
  animation: flickerAnimation 1.7s infinite;
}
.ignition-off-pin {
  opacity: 0.4;
}

.leaflet-div-icon {
  background: none !important;
  border: none !important;
}

.card-watermark {
  opacity: 0.2;
  margin-right: 14px;
}

.color-table-bar {
  border-left-color: #eee;
  border-left-width: 24px;
  border-left-style: solid;
}

.map-toggle {
  flex: 0 !important;
  position: absolute;
  z-index: 1000;
}

.topbar-icon {
  font-size: 100px;
  position: absolute;
  right: 0;
  display: flex;
  margin-top: -20px !important;
  margin-right: 30px;
}

.route-badge-container {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  color: #fff;
}

.route-badge {
  width: 70px;
  padding: 4px 6px;
  text-align: center;
  font-weight: 700;
  border-radius: 4px;
}

.btn-edit-asset{
  z-index:1000;
  position: absolute;
  
}

.dd-asset-map{
  height: calc(100vh - 320px);
  
}

.poi-text{
  color:#c3cfc0;
}

.road-poi-type{
  background-color: #673AB7;
  color: #fff;
  padding: 2px 4px;
  border-radius: 5px;
}


.road-a-type{
  background-color: #f44336;
  color: #fff;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-e-type{
  background-color: green;
  color: #fff;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-n-type{
  background-color: #F4DD0D;
  color: #000;
  padding: 2px 4px;
  border-radius: 5px;
}

.road-urban-type{
  background-color: #0194e0;
  color: #fff;
  padding: 2px 8px;
  border-radius: 5px;
}

.day-header{
  background-color: #eee;
  
}
.day-header td{
  padding: 6px 8px;
  font-weight: 600;
}
.location-row td{
  padding: 1px 0px;
}

.location-row:hover{
  background-color: #eee;
}

.marker-number{
  display: flex;
  justify-content: center;
  width: 28px;
  color: #fff;
  background-color: #777;
}

.highlighted-position-row{
  background-color: #f9bd6d !important;
}

.locations-textual{
  flex: 0;
  
  overflow-y: scroll !important;
  height: calc(100vh - 420px);
  min-height: 400px;
  
}
</style>
